'use strict';

module.exports = require('./src/knack-api-wrapper.js');
